import 'babel-polyfill'
//==========================================================
import Vue from 'vue';
import { router } from './router/router'
import VeeValidate, { Validator } from 'vee-validate'
import VueResource from 'vue-resource'

import App from './App.vue';
import fa from 'vee-validate/dist/locale/fa';
import * as VueGoogleMaps from "vue2-google-maps";
//==========================================================
import { store } from './store/store'
import { registerGlobalComponents } from './global-components';
import { registerGlobalFilters } from "./global-filters";
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
//==========================================================
Vue.use(VueResource);
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyB6w_TqF8RRH_zTOZFUzUZux1EVQ0LN7fU",
        libraries: "places" // necessary for places input
    }
});
Vue.use(VeeValidate, {
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    }
});
Vue.use(VuePersianDatetimePicker, {
    name: 'custom-date-picker',
    props: {
        inputFormat: 'YYYY/MM/DD',
        format: 'jYYYY/jMM/jDD',
        editable: false,
        inputClass: 'form-control border-radius-5',
        placeholder: 'انتخاب تاریخ ...',
        altFormat: 'YYYY/MM/DD',
        color: '#00acc1',
        autoSubmit: false,
         
    }
});

Validator.localize('fa', fa);
//==========================================================
registerGlobalComponents();
registerGlobalFilters();
//==========================================================
new Vue({
    router: router ,
    store,
    render: h => h(App),
   
}).$mount('#app');
//==========================================================
